import { Reforge } from "@hex-insights/uploads";
import { uploadsBucketName, uploadsReforgeURL } from "../settings";

export function getReforgeImageURL(key: string, edits: Reforge.ImageOptions["edits"]) {
	return Reforge.getImageURL(key + "/original", {
		baseURL: uploadsReforgeURL,
		bucket: uploadsBucketName,
		edits,
	});
}

export const reforgeSizeMultiple = 2;
